<template>
  <div class="vipElevator">
    <div class="vipElevator-name">
      <span>会员升降级分析</span>
    </div>
    <el-radio-group v-model="radio1" size="small">
      <el-radio-button label="0">降级人数</el-radio-button>
      <el-radio-button label="1">升级人数</el-radio-button>
    </el-radio-group>

    <div class="vipElevator-Cont">
      <div class="vipElevator-Cont-data">暂无数据</div>
      <div class="vipElevator-Cont-tj">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="排名" min-width="100"></el-table-column>
            <el-table-column prop="name" label="等级" min-width="300"></el-table-column>
            <el-table-column prop="name" label="该等级降级人数" min-width="100"></el-table-column>
            <el-table-column prop="name" label="占比" min-width="100"></el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      radio1: "0",
      tableData: []
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.vipElevator {
  padding: 16px;
  background: #fff;
  margin-bottom: 14px;

  .vipElevator-name {
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    height: 24px;
    margin-bottom: 20px;
  }

  .vipElevator-Cont {
    min-height: 300px;
    display: flex;

    .vipElevator-Cont-data {
      flex: 1;
      line-height: 300px;
      text-align: center;
    }
    .vipElevator-Cont-tj {
      flex: 1;
    }
  }
}
</style>


<style lang="scss">
.vipElevator {
  .el-table {
    th {
      background-color: #f7f8fa;
    }
  }
}
</style>
